import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError, locationSelector } from 'slices/locationSlice';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import PhoneInput from 'components/common/PhoneInput';
import { IconButton, Switch } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FullPageLoader from 'components/common/FullPageLoader';
import { usePermissions } from 'layouts/Admin';
import InterpreterRate from './InterpreterRate';
import { updateLocation } from 'slices/locationSlice';
import { addLocation } from 'slices/locationSlice';


const LocationForm = ({ item }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { checkPermission } = usePermissions()
  const methods = useForm();
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors, resetField, unregister } = methods;
  const { loader, error } = useSelector(locationSelector)
  const [status, setStatus] = useState(1);
  const [credentialsSend, setCredentialsSend] = useState(1);
  const [notification, setNotification] = useState(1);
  const [noOfVariants, setNoOfVariants] = useState([
    {
      field: '',
      required: 0
    }
  ]);
  const resetAllFields = () => {
    setValue('name', '');
    setValue('contact_name', '');
    setValue('contact_number', '');
    setValue('email', '');
    setValue('password', '');
    setValue('address', '');
    setValue('description', '');
    setValue("dynamic_fields", [])
    setStatus(1)
  }
  useEffect(() => {
    setValue('name', item?.user?.name || '');
    setValue('contact_name', item?.contact_name || '');
    setValue('contact_number', item?.contact_number || '');
    setValue('email', item?.user?.email || '');
    setValue('password', '');
    setValue('address', item?.address || '');
    setValue('description', item?.description || '');

    const temp_array = [];
    setValue("dynamic_fields", item?.dynamic_fields?.map(p => {
      temp_array.push({
        field: p?.name,
        id: p?.id,
        required: p?.required,
      })
      return p?.name
    }));

    temp_array?.length > 0 ? setNoOfVariants(temp_array) : setNoOfVariants([{ field: "", id: 1, required: 0 }]);

    setStatus((typeof (item?.status) == "number") ? item?.status : 1)
    setCredentialsSend((typeof (item?.user?.credentials_send) == "number") ? item?.user?.credentials_send : 1);
    setNotification((typeof (item?.user?.notifications) == "number") ? item?.user?.notifications : 1);

    dispatch(setError({}));

    return () => {
      resetAllFields();
    }

  }, [item])

  console.log("serverSideErrors", error);

  //#region Dynamic fields
  const handleAdd = React.useCallback(() => {
    const newVariants = [...noOfVariants];
    newVariants.push({
      field: "",
      id: newVariants.length + 1,
      required: false,
    });
    setNoOfVariants(newVariants);
  }, [noOfVariants]);

  const handleRemove = React.useCallback((index) => {
    const newVariants = [...noOfVariants];
    newVariants.splice(index, 1);
    setNoOfVariants(newVariants);
  }, [noOfVariants]);

  const toggleRequired = (index) => {
    const newVariants = [...noOfVariants];
    newVariants[index].required = !newVariants[index].required;
    setNoOfVariants(newVariants);
  };

  useEffect(() => {
    setValue('dynamic_fields', noOfVariants?.map((variant) => variant.field));
    setValue('dynamic_fields_required', noOfVariants?.map((variant) => variant.required ? 1 : 0));
  }, [noOfVariants, setValue]);

  const renderDynamicField = React.useCallback((variant, index) => {
    return (
      <>
        <div className="row-primary mb-0 align-items-center mt-2" key={variant?.id} id={variant?.id}>
          <Controller
            name={`dynamic_fields[${index}]`}
            control={control}
            render={({ field }) => (
              <input
                className="input-in type_inp"
                type="text"
                placeholder=""
                value={variant?.field}
                onChange={(e) => {
                  const newVariants = [...noOfVariants];
                  newVariants[index].field = e.target.value;
                  setNoOfVariants(newVariants);
                }}
              />
            )}
          />

          {noOfVariants?.length > 1 && (
            <IconButton color="error" onClick={() => handleRemove(index)}>
              <i className="fa-solid fa-trash-can trash_icon"></i>
            </IconButton>
          )}

          <div className="col-1">
            <h3 className="fst-italic mt-0">Required</h3>
            <Switch
              name={`dynamic_fields_required[${index}]`}
              checked={variant.required}
              onChange={() => toggleRequired(index)}
              color="primary"
            />
          </div>
        </div>
      </>
    );

  }, [noOfVariants, errors]);
  //#endregion


  const submitCallback = (status, message, errors) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      resetAllFields()
      navigate(-1)
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {

    dispatch(setError({}))
    const newData = {
      ...data,
      status,
      credentialsSend,
      notification,
    };

    if (item?.id) {
      dispatch(updateLocation(newData, item?.id, submitCallback));
    } else {
      dispatch(addLocation(newData, submitCallback));
    }
  }

  return (
    <>
      <FormProvider {...methods}>
        <form className='card_table p-4' onSubmit={handleSubmit(onSubmit)}>
          <div className="container_main">
            <div className="page_modal">
              <button type='button' className="main_heading back_button" onClick={() => navigate(-1)}>
                <i className="fa-solid fa-arrow-left"></i> Back
              </button>
              <h2 className="main_heading">{item ? 'Update' : 'Add'} Location</h2>
            </div>

            {/* Main credientials area  */}
            <div className='foam_page_row'>
              <div className="row-primary row_secondary">
                <h2>Location Name *</h2>
                <div className='w-100'>
                  <Controller
                    name="name"
                    rules={{
                      required: "Location name is required"
                    }}
                    control={control}
                    render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Name' {...field} />}
                  />
                  {error?.errors?.name?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                  {errors?.name?.message &&
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.name?.message} />
                    </div>
                  }
                </div>
              </div>

              <div className="row-primary row_secondary">
                <h2>Contact Name *</h2>
                <div className='w-100'>
                  <Controller
                    name="contact_name"
                    rules={{
                      required: "Contact name is required"
                    }}
                    control={control}
                    render={({ field }) => <input className="input-in type_inp" type="text" name='contact_name' placeholder='Contact Name' {...field} />}
                  />
                  {error?.errors?.contact_name?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                  {errors?.contact_name?.message &&
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.contact_name?.message} />
                    </div>
                  }
                </div>
              </div>

              <div className="row-primary row_secondary">
                <h2>Contact Number</h2>
                <div className='w-100'>
                  <Controller
                    name="contact_number"
                    control={control}
                    render={({ field }) => <PhoneInput className={`input-in type_inp ${error?.errors?.contact_number ? "border-red" : ""} `}
                      type="tel" name='contact' placeholder='Phone number' {...field} />
                    }
                  />
                  {error?.errors?.contact_number?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              </div>

              <div className="row-primary row_secondary">
                <h2>Email *</h2>
                <div className='w-100'>
                  <Controller
                    name="email"
                    rules={{
                      required: "Email is required"
                    }}
                    control={control}
                    render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" autoComplete="off" name='email'
                      pattern={
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                      }
                      placeholder="Email Address"
                      {...field}
                    />
                    }
                  />
                  {error?.errors?.email?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                  {errors?.email?.message &&
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.email?.message} />
                    </div>
                  }
                </div>
              </div>

              <div className="row-primary row_secondary">
                <h2>Password {!item && '*'}</h2>
                <div className='w-100'>
                  <Controller
                    name="password"
                    rules={!item && {
                      required: "Email is required"
                    }}
                    control={control}
                    render={({ field }) =>
                      <input className={`input-in type_inp `} autoComplete="off" type="password" name='password' placeholder="Password" {...field}
                        disabled={watch("type") == "interpreter" ? true : false}
                      />}
                  />
                  {error?.errors?.password?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                  {errors?.password?.message &&
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.password?.message} />
                    </div>
                  }
                </div>
              </div>

              <div className="row-primary row_secondary">
                <h2>Address *</h2>
                <div className='w-100'>
                  <Controller
                    name="address"
                    rules={{
                      required: "Contact name is required"
                    }}
                    control={control}
                    render={({ field }) => <input className="input-in type_inp" type="text" name='address' placeholder='Address' {...field} />}
                  />
                  {error?.errors?.address?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                  {errors?.address?.message &&
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.address?.message} />
                    </div>
                  }
                </div>
              </div>

              <div className="row-primary row_secondary flex-basis-full">
                <h2>Description</h2>
                <div className='w-100'>
                  <Controller
                    name="description"
                    control={control}
                    render={({ field }) => <textarea className="input-in type_inp" rows={3} name='description' placeholder='Description' {...field} />}
                  />
                  {error?.errors?.description?.map((error) => (
                    <div style={{ marginTop: 10 }}>
                      <ErrorMessage text={error} />
                    </div>
                  ))}
                </div>
              </div>

              <div className="row-primary align-items-center gap-0">
                <label className="custom-checkbox checkbox">
                  <input
                    type="checkbox"
                    name="credentials_send"
                    checked={credentialsSend === 1 ? true : false}
                    onChange={(e) => setCredentialsSend(e.target.checked ? 1 : 0)}
                  />
                  <span className="checkmark"></span>
                </label>
                <h2 className='m-0'>Credentials will be sent over email</h2>
              </div>

              <div className="row-primary align-items-center justify-content-between">
                <h2 className='mt-0'>Notifications<br />
                <small className='opacity-50' style={{fontSize: 12}}>(all type of notification regarding appointments)</small></h2>
                <CustomSwitch
                  labelText="notifications"
                  checked={notification == 1 ? true : false}
                  handleChange={(checked) => setNotification(checked ? 1 : 0)}
                />
              </div>
            </div>

            {/* Dynamic fields  */}
            {/* <div className='w-100 dynamic_fields'>
            <hr />
            <div className="row-primary row-r justify-content-between flex-row">
              <h2>Dynamic Fields </h2>
              <SubmitButton btnText='Add' buttonType='button' handleSubmit={handleAdd} />
            </div>
            {noOfVariants?.map((variant, index) => renderDynamicField(variant, index))}
            <hr />
          </div> */}

            <InterpreterRate control={control} errors={errors} item={item} setValue={setValue} watch={watch} isClient={true} />

            <div className="Form-footer footer_fullpage">

              <div className="row-primary m-0 align-items-center">
                {checkPermission('Status Client Account') &&
                  <>
                    <h2 className='mt-0'>Status</h2>
                    <CustomSwitch
                      labelText="active"
                      checked={status == 1 ? true : false}
                      handleChange={(checked) => setStatus(checked ? 1 : 0)}
                    />
                  </>
                }
              </div>

              <SubmitButton
                loader={loader}
                btnText={item?.id ? "Update" : "Create"}
              />
            </div>

          </div>
        </form>
      </FormProvider>

      {loader
        &&
        <FullPageLoader />
      }
    </>
  )
}

export default LocationForm;